import Button from "../ui/buttons/Button";
import RegisterMultiStepStyle from "../../style/components/auth/RegisterMultiStepForm.module.css";
import { useCompany } from "../../hooks/useAuth";
import Loader from "../ui/Loader/Loader";

export const CompanyMultiStepForm = ({ steps, onSubmit }) => {
  const {
    currentStep,
    formData,
    stepErrors,
    isSubmitting,
    handleChange,
    nextStep,
    prevStep,
    submit,
    setSelectedImage,
    selectedImage,
  } = useCompany({ steps, onSubmit });

  const CurrentStep = steps[currentStep].component;

  return (
    <div>
      <CurrentStep
        formData={formData}
        onChange={handleChange}
        errors={stepErrors}
        setSelectedImage={setSelectedImage}
        selectedImage={selectedImage}
      />

      <div className={RegisterMultiStepStyle.RegisterMultiStepFormButton}>
        {/* {currentStep > 0 && currentStep < steps.length - 1 && (
                    <Button
                        type="button"
                        variant="outline"
                        onClick={prevStep}
                        disabled={isSubmitting}
                    >
                        Back
                    </Button>
                )} */}
        {currentStep < steps.length - 1 ? (
          <Button onClick={nextStep} disabled={isSubmitting}>
            {isSubmitting ? <Loader /> : "Continue"}
          </Button>
        ) : (
          <>
            <Button
              type="button"
              variant="outline"
              onClick={prevStep}
              disabled={isSubmitting}
            >
              Back
            </Button>
            <Button onClick={submit} disabled={isSubmitting}>
              {isSubmitting ? <Loader /> : "Submit"}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
